/**
 * iOS App Store CTA — a **non-functional stub** (#103 D103.5; the real app is #104).
 *
 * Signals the roadmap without shipping a dead App Store link: it is not an anchor and
 * has no `href`/click target, and it carries a visible "Coming soon" treatment plus
 * `aria-disabled` so assistive tech announces it as unavailable. The final coming-soon
 * styling is the owner's to polish before ship; this keeps it honestly inert until then.
 */

export function IosBadge(): React.JSX.Element {
  return (
    <div
      className="landing-store-badge landing-store-badge--soon"
      data-testid="ios-cta"
      role="note"
      aria-disabled="true"
      aria-label="iOS app — coming soon"
    >
      <span className="landing-store-badge__text">
        <small>Coming soon</small>
        <strong>iOS app</strong>
      </span>
    </div>
  );
}
